import { Controller } from "@hotwired/stimulus"
import { captureAvatarPng, csrfToken } from "../../lib/avatar_capture"

export default class extends Controller {
  static values = { url: String, text: String, captureUrl: String, avatarSeed: String }
  static targets = ["feedback", "native"]

  connect() {
    if (navigator.share && this.hasNativeTarget) this.nativeTarget.classList.replace("hidden", "flex")
    if (this.hasCaptureUrlValue) this.backfillAvatar()
  }

  async backfillAvatar() {
    try {
      const blob = await captureAvatarPng(this.avatarSeedValue)
      const formData = new FormData()
      formData.append("avatar_image", blob, "avatar.png")

      await fetch(this.captureUrlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken() },
        body: formData
      })
    } catch {}
  }

  async share() {
    if (!navigator.share) return
    try {
      await navigator.share({ url: this.urlValue, text: this.textValue })
    } catch {}
  }

  async copy() {
    await navigator.clipboard.writeText(this.urlValue)
    if (!this.hasFeedbackTarget) return
    this.feedbackTarget.classList.remove("hidden")
    clearTimeout(this.feedbackTimeout)
    this.feedbackTimeout = setTimeout(() => this.feedbackTarget.classList.add("hidden"), 2000)
  }
}
